export interface TsAppVersion {
    version: string;
    name: string;
    description?: string;
    versionLong?: string;
    versionDate: string;
    gitCommitHash?: string;
    gitCommitDate?: string;
    gitTag?: string;
};
export const versions: TsAppVersion = {
    version: '2.5.5',
    name: 'fpar',
    versionDate: '2026-01-08T18:40:12.035Z',
};
export default versions;
